import { Box } from '@chakra-ui/react'
import SlickSlider from 'react-slick'


export function Slider({children, settings}) {
  return (
    <Box className="wrapperSlider">
      <SlickSlider {...settings}>{children}</SlickSlider>
    </Box>
  )
}